

























































































































import Component from 'vue-class-component'
import { IResident, IResidentContact, IStatement } from '@zunta/configurations'
import StatementResidentContact from '@/views/app/management/review-statements/components/StatementResidentContact.vue'
import { Watch } from 'vue-property-decorator'
import ScrollView from '@/components/ScrollView.vue'
import SharedFunctions from '@/views/app/management/review-statements/SharedFunctions'
import Icon from '@/components/Icon.vue'
import ChangeMailContactModal from '@/views/app/management/review-statements/components/ChangeMailContactModal.vue'
import Switcher from '@/components/Switcher.vue'

import Confirm from '@/components/Confirm.vue'
import { STATEMENT_STATUSES_LABEL_MAP } from '@/constants'

@Component({
  components: {
    Switcher,
    Confirm,
    ChangeMailContactModal,
    Icon,
    ScrollView,
    StatementResidentContact
  }
})
export default class ResidentContactsList extends SharedFunctions {
  isEdited: boolean = false
  changeMainContactModalState: boolean = false
  changeStatusMessage: string = ''
  needConfirmChangeStatus: boolean = false

  get batchID () {
    return this.$route.params.batch
  }

  get residentName () {
    if (!this.resident) return ''
    return (this.resident.firstName ? this.resident.firstName : '') + ' ' +
      (this.resident.lastName ? this.resident.lastName : '')
  }

  mounted () {
    this.$eventBus.$on('statementReview:closeConfirmChangeStatus', () => {
      this.needConfirmChangeStatus = false
    })
    this.$eventBus.$on('statementReview:confirmChangeStatus', (status: any) => {
      this.changeStatusMessage = `Are you sure you would like to approve this statement? The current status is ${STATEMENT_STATUSES_LABEL_MAP[status]}.`
      this.needConfirmChangeStatus = true
    })
  }

  beforeDestroy () {
    this.$eventBus.$off('statementReview:closeConfirmChangeStatus')
    this.$eventBus.$off('statementReview:confirmChangeStatus')
  }

  setDeliverToRoom (value: boolean) {
    const payload = {
      deliverToRoom: value,
      contacts: this.residentContacts.map((item: IResidentContact) => {
        return {
          id: item.id,
          isAddressUsedForMailing: item.isAddressUsedForMailing,
          isEmailUsedForMailing: item.isEmailUsedForMailing
        }
      }),
      batchId: this.batchID
    }
    this.saveContactsForMailing(payload)
  }

  @Watch('batchStatements', { immediate: true })
  onBatchStatementsChange (value: any) {
    if (value && value.length && this.selectedStatement && this.selectedStatement.id) {
      // @ts-ignore
      const index = value.findIndex((item: any) => item.id === this.selectedStatement.id)
      this.scrollTo(index > -1 ? index : 0)
    }
  }

  closeConfirm () {
    this.needConfirmChangeStatus = false
  }

  confirmChangeStatus () {
    this.$eventBus.$emit('statementReview:changeStatusConfirmed')
    this.$eventBus.$emit('comments:update')
    this.needConfirmChangeStatus = false
  }

  scrollTo (toElementIndex: number = 0) {
    this.$nextTick(() => {
      const area = document.getElementById('related-contact-scroll-area')
      if (!area) return
      let offset = 0
      const cards = document.querySelectorAll('#related-contact-scroll-area .card')
      if (!cards.length) return
      if (toElementIndex) {
        for (let i = 0; i < toElementIndex; i++) {
          // @ts-ignore
          if (cards[i].offsetHeight) {
            // @ts-ignore
            offset += cards[i].offsetHeight + 10
          }
        }
      }
      area.scrollTo(0, offset)
    })
  }

  toggleChangeMailContact (value: boolean) {
    this.changeMainContactModalState = value
  }

  async closeChangeMailContactModal () {
    this.toggleChangeMailContact(false)
    await this.fetchData()
  }

  async saveContactsForMailing (payload: any) {
    const residentId = this.resident.id
    const statementId = this.statementID
    this.$eventBus.$emit('loading:enable', { message: 'Updating' })
    const response = await this.residentModuleInstance.updateResidentContactsForMailing({
      residentId: residentId,
      payload: payload
    })
    if (response && response.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: Array.isArray(response.error) ? response.error.join('\n') : response.error,
        header: `Edit Recipients`,
        icon: 'warning'
      })
      this.$eventBus.$emit('loading:disable')
      this.toggleChangeMailContact(false)
      return
    }

    this.toggleChangeMailContact(false)

    await Promise.all([
      this.batchModuleInstance.fetchBatch(this.batchID),
      this.fetchList()
    ])

    const currentStatement = this.statementList.find((statement: IStatement) => Number(statementId) === statement.id)
    const statementWithCurrentResident = this.statementList.find((statement: IStatement) =>
      statement.resident && ((statement.resident as IResident).id as number) === residentId)

    if (!currentStatement) {
      if (statementWithCurrentResident) {
        await this.changeStatement(statementWithCurrentResident.id)
        return
      }
      await this.nextStatement()
      return
    }

    await Promise.all([
      this.updateStatistics(),
      // this.commentModuleInstance.fetchStatementComments((this.selectedStatement as IStatement).id),
      this.statementModuleInstance.fetchStatementMessages({
        statementId: ((this.selectedStatement as IStatement).resident as IResident).id,
        batchId: this.batchID
      }),
      this.fetchContactsList(),
      this.getRelatedResidents()
    ])

    // await this.fetchData()
    // await this.getRelatedResidents(residentId)
    this.$eventBus.$emit('loading:disable')
    this.$eventBus.$emit('comments:update')
  }

  @Watch('selectedStatement')
  onSelectedStatement () {
    this.fetchContactsList()
    this.getRelatedResidents()
  }
}
